export default "__VITE_ASSET__DnWh9GKV__"